import { Box, CircularProgress, useTheme } from '@mui/material';

export const LoadingState = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={theme.spacing(50)}
      sx={{
        backgroundColor: theme.palette.background.default,
      }}
    >
      <CircularProgress
        color="primary"
        size={theme.spacing(5)}
      />
    </Box>
  );
};
